import React from 'react';
import { useSelector } from 'react-redux';
import { isRequiredFeatureEnabled } from 'src/components/auth';
import { FileUploadProvider } from 'src/components/molecules';
import { useGetPublicFeaturesQuery } from 'src/graphql';
import * as Types from 'src/types';

export const ReportViewProvider = ({
  children,
  organisation,
}: {
  children: React.ReactNode;
  organisation: string;
}) => {
  const { data: publicFeatures } = useGetPublicFeaturesQuery(
    {
      slug: organisation,
    },
    {
      enabled: organisation !== '',
    },
  );

  const organisationId = useSelector(
    (state: Types.State) => state.organisation?.organisation?.id,
  );

  const isSegmentEnabled = publicFeatures?.getPublicFeatures
    ? isRequiredFeatureEnabled(
        publicFeatures.getPublicFeatures as Types.Feature[],
        Types.FeatureFlag.FRONTEND_SEGMENT_TRACKING,
      )
    : false;

  return (
    <FileUploadProvider
      id="opr-post-sub-file-upload"
      organisationId={organisationId}
      segmentEnabled={isSegmentEnabled}
      submissionType={Types.SubmissionType.POST_SUBMISSION}
      platform={Types.Platform.OPR}
    >
      {children}
    </FileUploadProvider>
  );
};
